import React from "react";
import { Routes, Route } from "react-router-dom";
import TokenValidator from "./components/TokenValidator/TokenValidator";
import MyInformation from "./components/MyInformation/MyInformation";
import NotFound from "./components/NotFound/NotFound";

const App: React.FC = () => {
  return (
    <div className="App">
      <Routes>
        {/* Explicit confirmation route */}
        <Route path="/:tokenID/confirm/:email" element={<TokenValidator isConfirmationRoute={true} />} />

        {/* Regular token validation route */}
        <Route path="/:tokenID" element={<TokenValidator isConfirmationRoute={false} />} />

        {/* Email verification route */}
        <Route path="/:tokenID/my" element={<TokenValidator isMyInformationRoute={true} />} />

        {/* 404 Not Found Route */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </div>
  );
};

export default App;